// The categories the site navigates by, matching categoryList.json in the
// frontend and the ids stored on each store.
//
// A store belongs to exactly one, and its coupons inherit it — coupons carry no
// category of their own. Kept as a fixed list rather than free text because
// free text is how the data ended up with "extra", "cosmetics" and
// "media-entartainment" as separate headings from the real ones.
export const CATEGORIES = [
  { id: "art", name: "Art" },
  { id: "automobile", name: "Automobile" },
  { id: "beauty", name: "Beauty" },
  { id: "body-care", name: "Body Care" },
  { id: "building-supplies", name: "Building Supplies" },
  { id: "e-commerce", name: "E-Commerce" },
  { id: "electronics", name: "Electronics" },
  { id: "fashion", name: "Fashion" },
  { id: "fitness-health", name: "Fitness & Health" },
  { id: "food", name: "Food" },
  { id: "furniture", name: "Furniture" },
  { id: "gaming", name: "Gaming" },
  { id: "gifts", name: "Gifts" },
  { id: "home-decor", name: "Home Decor" },
  { id: "kids", name: "Kids" },
  { id: "kitchen-dining", name: "Kitchen & Dining" },
  { id: "media-entertainment", name: "Media & Entertainment" },
  { id: "movers-packers", name: "Movers-Packers" },
  { id: "pets", name: "Pets" },
  { id: "sports", name: "Sports" },
  { id: "travel", name: "Travel" },
  { id: "utilities", name: "Utilities" },
  { id: "web-services", name: "Web Services" },
  { id: "extras", name: "Extras" },
];

export const CATEGORY_IDS = CATEGORIES.map((c) => c.id);

// Where a store with no category of its own is listed.
export const DEFAULT_CATEGORY = "extras";

export const categoryName = (id) =>
  CATEGORIES.find((c) => c.id === id)?.name || id || "Uncategorised";
